import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";
import selectHelper from "../../../Helpers/selectHelper";

export default class IobLineItemSearchParams extends SearchParamsBase {
	static iconName = "fa-solid fa-search";
	static saveType = "IobLineItemSearchParams";
	static maxWidth = 1000;

	initialize() {
		const urlParams = new URLSearchParams(window.location.search);

		this.IobInvoiceId = urlParams.get('id');
		this.IoblineItemId = "";
		this.Type = "";
		this.AssignmentApolloId = "";
		this.SelectedAssignmentCountries = [];
		this.SelectedEvaluatorCountries = [];
		this.SelectedTpLocationCountries = [];
		this.SelectedTpEvaluatorCountries = [];
		this.SelectedStatuses = [];
	}

	static getSelectValuesForType() {
		return selectHelper.generateSelectValues(["Translations", "Research", "Editing/Datacheck", "Misc Labor", "Other", "Fieldwork Fees", "Evaluator Fees", "Evaluator Expenses", "Transaction & Admin Fees", "Adjusting Fieldwork Fees", "Adjusting Fieldwork Reimbursements", "Adjusting Evaluator Fees", "Adjusting Evaluator Reimbursements", "Adjusting Prior Ad Hoc IOB"]);
	}

	static getStatusValues() {
		return [
			{ label: "", value: "", disabled: false },
			{ label: "Created", value: "Created", disabled: false },
			{ label: "New", value: "New", disabled: false },
			{ label: "Incomplete", value: "Incomplete", disabled: false },
			{ label: "Completed", value: "Completed", disabled: false },
			{ label: "Collaboration Shop", value: "Collaboration Shop", disabled: false },
			{ label: "Excluded", value: "Excluded", disabled: false },
			{ label: "Hold A", value: "Hold A", disabled: false },
			{ label: "Hold B", value: "Hold B", disabled: false },
			{ label: "Reviewed", value: "Reviewed", disabled: false },
			{ label: "Finalized", value: "Finalized", disabled: false },
			{ label: "Emailed", value: "Emailed", disabled: false },
			{ label: "Client Finalized", value: "Client Finalized", disabled: false },
			{ label: "Locked", value: "Locked", disabled: false },
			{ label: "Deleted in Apollo", value: "Deleted in Apollo", disabled: false },
		];
	}

	static fieldsInSearchBox = [
		{ fieldName: "IoblineItemId", label: "Line Item ID", className: "col-4", type: InputTypesEnum.Text },
		{ fieldName: "Type", label: "Type", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getSelectValuesForType() },
		{ fieldName: "SelectedAssignmentCountries", label: "Assignment Country", className: "col-4", type: InputTypesEnum.CountryMultiChoice },
		{ fieldName: "SelectedEvaluatorCountries", label: "Evaluator Country", className: "col-4", type: InputTypesEnum.CountryMultiChoice },
		{ fieldName: "AssignmentApolloId", label: "Apollo Assignment ID", className: "col-4", type: InputTypesEnum.Text },
		{ fieldName: "SelectedStatuses", label: "Status", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getStatusValues() }
	];
}